/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Cleans an object of HTTP parameters by removing entries with `null` or `undefined` values
 * and converting all remaining values to strings.
 *
 * @param params - An object containing key-value pairs of HTTP parameters.
 *                 The values can be of any type.
 * @returns A new object containing only the entries with non-null and non-undefined values,
 *          where all values are converted to strings.
 */
export function cleanHttpParams(params: Record<string, any>): Record<string, string> {
  return (
    Object.entries(params)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, value]) => value !== null && value !== undefined && value !== '')
      .reduce(
        (acc, [key, value]) => {
          acc[key] = String(value)
          return acc
        },
        {} as Record<string, string>
      )
  )
}
